export default __webpack_public_path__ + "static/media/mobile-img-ovato-hf.fc0f498d.png";